// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { SetCartDatesHasErrorsParameter } from "@store/Framework/Store/Greif/Pages/Cart/RequestedDates/Handlers/SetCartDatesHasError";
import { SetDisplayCartDateErrorsParameter } from "@store/Framework/Store/Greif/Pages/Cart/RequestedDates/Handlers/SetDisplayCartDateErrors";
import { SetIsEditingDatesParameter } from "@store/Framework/Store/Greif/Pages/Cart/RequestedDates/Handlers/UpdateIsEditingDates";

import { Draft } from "immer";

type RequestedDateState = Toolkit.Store.Greif.Pages.Cart.RequestedDate.State;

const initialState: RequestedDateState = {
    isEditingDate: true,
    hasErrors: false,
    displayCartDateErrors: false,
};

const actions = {
    "Greif/Pages/CartRequestedDate/SetIsEditingDate": (
        draft: Draft<RequestedDateState>,
        action: SetIsEditingDatesParameter,
    ) => {
        draft.isEditingDate = action.isEditingDate;
    },
    "Greif/Pages/CartRequestedDate/SetCartDatesHasError": (
        draft: Draft<RequestedDateState>,
        action: SetCartDatesHasErrorsParameter,
    ) => {
        draft.hasErrors = action.hasErrors;
    },
    "Greif/Pages/CartRequestedDate/SetDisplayCartDateErrors": (
        draft: Draft<RequestedDateState>,
        action: SetDisplayCartDateErrorsParameter,
    ) => {
        draft.displayCartDateErrors = action.displayCartDateErrors;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type GreifCartPagesReducerRequestedDateActions = Parameters<typeof reducer>[1];
export default reducer;
